import RewardsExchangeRate from "./js/RewardsExchangeRate";
export default RewardsExchangeRate;
